import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/AuthService/auth.service';
import { ModuloService } from 'src/app/services/ModuloService/modulo.service';
import { BRAND } from '../../constants/brand';
import { validarPermissao } from '../../utils/permissionScreen/permissionScreen';
import { IOpcaoTela } from '../../utils/permissionScreen/permissionScreen.types';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  readonly brand = BRAND;
  authService = inject(AuthService);

  private readonly telasDashboardServicos: IOpcaoTela[] = [
    'graficoServicosIndicadorLimpezas',
    'graficoServicosIndicadorAgendamentos',
    'graficoServicosIndicadorMediaCaminhoes',
    'graficoServicosIndicadorTerminaisAtivos',
    'graficoServicosIndicadorReceita',
    'graficoLimpezasPorMes',
    'graficoLimpezasPorTerminal',
    'graficoLimpezasPorTransportadora',
    'graficoLimpezasAgendadas',
    'graficoMediaMensalServico',
    'graficoVendasQtdTipoServico',
    'graficoVendasValorTipoServico',
    'graficoDistribuicaoFormaPagamento',
    'graficoValoresFormaPagamento'
  ];

  private readonly telasDashboardPatio: IOpcaoTela[] = [
    'graficoPatioTotalVeiculos',
    'graficoPatioAgendadoTerminais',
    'graficoPatioTotalNoPatio',
    'graficoPatioTempoPermanencia',
    'graficoPatioDiarioTotal',
    'graficoPatioAgendamentosD',
    'graficoPatioAgendamentosD1',
    'graficoPatioAgendamentosD2',
    'graficoPatioEstacionamento',
    'graficoPatioTurnos'
  ];

  constructor(
    private router: Router,
    private moduloService: ModuloService
  ) {}

  get podeVerDashboardServicos(): boolean {
    return this.podeVerDashboard(this.telasDashboardServicos);
  }

  get podeVerDashboardPatio(): boolean {
    return this.podeVerDashboard(this.telasDashboardPatio);
  }

  get podeVerDashboardFinanceiro(): boolean {
    return this.podeVerDashboard(['dashboardFinanceiro']);
  }

  getNome(): string {
    const nome = String(localStorage.getItem('nome'));
    return nome;
  }

  logout(): void {
    localStorage.clear();
    this.router.navigate(['login']);
  }

  navigateHome(): void {
    this.router.navigate(['home']);
  }

  irDashboardServicos(): void {
    this.router.navigate(['listagem/relatorios/dashboard-servicos']);
  }

  irDashboardPatio(): void {
    this.router.navigate(['listagem/relatorios/dashboard-patio']);
  }

  irDashboardFinanceiro(): void {
    this.router.navigate(['listagem/relatorios/dashboard-financeiro']);
  }

  private podeVerDashboard(telas: IOpcaoTela[]): boolean {
    return (
      this.moduloService.isModuloAtivo('Report') &&
      telas.some(tela => validarPermissao(tela, 'consultar'))
    );
  }
}
